export const initTwoOptionsWouldYouRatherReducer = {
    introvoice: {
      text: "",
      voice: "",
    },
    explainervoice: {
      text: "",
      voice: "",
    },
    commentsvoice: {
      text: "",
      voice: "",
    },
    subscribevoice: {
      text: "",
      voice: "",
    },
    items: [
      {
        option1: {
          name: "",
          prompt: "",
          query: "",
          images: [],
          selection: "",
        },
        option2: {
          name: "",
          prompt: "",
          query: "",
          images: [],
          selection: "",
        },
        voice: {
          text: "",
          voice: "",
        },
      },
    ],
  };

export const initThreeOptionsWouldYouRatherReducer = {
    introvoice: {
      text: "",
      voice: "",
    },
    explainervoice: {
      text: "",
      voice: "",
    },
    commentsvoice: {
      text: "",
      voice: "",
    },
    subscribevoice: {
      text: "",
      voice: "",
    },
    items: [
      {
        option1: {
          name: "",
          prompt: "",
          query: "",
          images: [],
          selection: "",
        },
        option2: {
          name: "",
          prompt: "",
          query: "",
          images: [],
          selection: "",
        },
        option3: {
          name: "",
          prompt: "",
          query: "",
          images: [],
          selection: "",
        },
        voice: {
          text: "",
          voice: "",
        },
      },
    ],
  };
  

  export const initMysteryWouldYouRatherReducer = {
    introvoice: {
      text: "",
      voice: "",
    },
    explainervoice: {
      text: "",
      voice: "",
    },
    commentsvoice: {
      text: "",
      voice: "",
    },
    subscribevoice: {
      text: "",
      voice: "",
    },
    items: [
      {
        option1: {
          name: "",
          prompt: "",
          query: "",
          images: [],
          selection: "",
        },
        option2: {
          name: "",
          query: "",
          prompt: "",
          images: [],
          selection: "",
        },
        option3: {
          name: "",
          query: "",
          prompt: "",
          images: [],
          selection: "",
        },
        voice: {
          text: "",
          voice: "",
        },
      },
    ],
  };

  export const initTwoOptionsCorrectAnswerReducer = {
    introvoice: {
      text: "",
      voice: "",
    },
    explainervoice: {
      text: "",
      voice: "",
    },
    commentsvoice: {
      text: "",
      voice: "",
    },
    subscribevoice: {
      text: "",
      voice: "",
    },
    items: [
      {
        option1: {
          name: "",
          prompt: "",
          query: "",
          images: [],
          selection: "",
          isCorrect: false,
        },
        option2: {
          name: "",
          prompt: "",
          query: "",
          images: [],
          selection: "",
          isCorrect: false,
        },
        voice: {
          text: "",
          voice: "",
        },
        answer: {
          text: "",
          voice: "",
        },
      },
    ],
  };

  export const initChooseYesOrNoButtonReducer = {
    introvoice: {
      text: "",
      voice: "",
    },
    explainervoice: {
      text: "",
      voice: "",
    },
    commentsvoice: {
      text: "",
      voice: "",
    },
    subscribevoice: {
      text: "",
      voice: "",
    },
    items: [
      {
        option: {
          text: "",
          selection: "",
          query: "",
          prompt: "",
          images: []
        },
        voice: {
          text: "",
          voice: "",
        },
        answer: {
          text: "",
          voice: ""
        }
      },
    ],
  }

  export const initGuessTheCharacterByVoiceReducer = {
    introvoice: {
      text: "",
      voice: "",
    },
    explainervoice: {
      text: "",
      voice: "",
    },
    commentsvoice: {
      text: "",
      voice: "",
    },
    subscribevoice: {
      text: "",
      voice: "",
    },
    items: [
      {
        option: {
          text: "",
          selection: "",
          query: "",
          prompt: "",
          images: []
        },
        voice: {
          text: "",
          voice: "",
        },
        answer: {
          text: "",
          voice: ""
        }
      },
    ],
  }

  export const initFromCharacterToAiPhotoReducer = {
    introvoice: {
      text: "",
      voice: "",
    },
    explainervoice: {
      text: "",
      voice: "",
    },
    commentsvoice: {
      text: "",
      voice: "",
    },
    subscribevoice: {
      text: "",
      voice: "",
    },
    items: [
      {
        character: {
          name: "",
          prompt: "",
          query: "",
          images: [],
          selection: "",
          voice: {
            text: "",
            voice: ""
          },
          video: ""
        },
        mutation: {
          name: "",
          prompt: "",
          query: "",
          images: [],
          selection: "",
          voice: {
            text: "",
            voice: ""
          },
          video: ""
        },
      },
    ],
  };


  export const initGuessByEmojiReducer = {
    title: "",
    introvoice: {
      text: "",
      voice: "",
    },
    explainervoice: {
      text: "",
      voice: "",
    },
    commentsvoice: {
      text: "",
      voice: "",
    },
    subscribevoice: {
      text: "",
      voice: "",
    },
    items: [
      {
        name: { text: "" },
        emojis: [
          { prompt: "", image: "" } // start with one empty emoji object
        ],
        voice: { text: "", voice: "" },
        answer: { text: "", voice: "" },
      },
    ],
  };
    

  export const initNeverHaveIEverReducer = {
    title: "",
    introvoice: {
      text: ""
    },
    explainervoice: {
      text: "",
      voice: "",
    },
    commentsvoice: {
      text: "",
      voice: "",
    },
    subscribevoice: {
      text: "",
      voice: "",
    },
    items: [
      {
        voice: {
          text: ""
        },
        option: {
          name: "",
          prompt: "",
          query: "",
          images: [],
          selection: ""
        }
      }
    ]
  };
  
  // initTestYourKnowledgeReducer.js
export const initTestYourKnowledgeReducer = {
  title: "",
  introvoice: {
    text: "",
    voice: "",
  },
  explainervoice: {
    text: "",
    voice: "",
  },
  commentsvoice: {
    text: "",
    voice: "",
  },
  subscribevoice: {
    text: "",
    voice: "",
  },
  items: [
    {
      question: { text: "" },
      option1: { text: "", isCorrect: false },
      option2: { text: "", isCorrect: false },
      option3: { text: "", isCorrect: false },
      answer: { text: "", voice: "" },
      preImage: { prompt: "", query: "", images: [], selection: "" },
      postImage: { prompt: "", query: "", images: [], selection: "" },
    },
  ],
};


export const initChooseYourGiftReducer = {
  introvoice: {
    text: "",
    voice: "",
  },
  explainervoice: {
    text: "",
    voice: "",
  },
  commentsvoice: {
    text: "",
    voice: "",
  },
  subscribevoice: {
    text: "",
    voice: "",
  },
  items: [
    {
      title: "",
      option1: {
        name: "",
        prompt: "",
        query: "",
        images: [],
        selection: "",
      },
      option2: {
        name: "",
        prompt: "",
        query: "",
        images: [],
        selection: "",
      },
      option3: {
        name: "",
        prompt: "",
        query: "",
        images: [],
        selection: "",
      },
      voice: {
        text: "",
        voice: "",
      },
    },
  ],
};

